import React from 'react';
import PropTypes from 'prop-types';
import { Spin } from 'antd';

// Sprint 2.4 (Enterprise Design System Foundation): standardizes the ad hoc `<Spin size="large"/>` +
// isLoading-boolean pattern already used ad hoc across many existing pages. Existing pages are not
// forced to migrate — this is for new Sprint 2.4 pages and available for future reuse.
const LoadingSpinner = ({ size, tip }) => (
  <div className="ent-loading-spinner" role="status" aria-live="polite">
    <Spin size={size || 'large'} tip={tip} />
  </div>
);

LoadingSpinner.propTypes = {
  size: PropTypes.oneOf(['small', 'default', 'large']),
  tip: PropTypes.string
};

export default LoadingSpinner;
